const SET_TOKEN = "SET_TOKEN"

export const setToken = (token: string ) => ({ type: SET_TOKEN, payload: { token }})

export default (state = { token: null }, action) => {
    switch(action.type) {
        case SET_TOKEN:
            return {...state, token: action.payload.token}
        default:
            return state
    }
}